module.exports = __webpack_public_path__ + "static/img/gansu.a49be88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/gansu.png
// module id = fH6M
// module chunks = 93